import React, { useState } from 'react';
import SafeIcon from '../../common/SafeIcon';
import { useStore } from '../../context/StoreContext';

const AdminAds = () => {
  const { ads, setAds } = useStore();
  const [formData, setFormData] = useState(ads);
  const [saved, setSaved] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setAds(formData);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="max-w-3xl">
      <div className="mb-8">
        <h1 className="text-2xl font-bold">Marketing & Ads</h1>
        <p className="text-muted text-sm">Manage the hero section and promotional banners</p>
      </div>

      <form onSubmit={handleSubmit} className="bg-dark-surface border border-dark-border rounded-xl p-6 space-y-6">
        
        <div className="flex items-center justify-between p-4 bg-dark-card border border-dark-border rounded-lg">
          <div>
            <h3 className="font-semibold">Enable Hero Banner</h3>
            <p className="text-sm text-muted">Show the large promotional banner at the top of the home page</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input 
              type="checkbox" 
              className="sr-only peer"
              checked={formData.heroAdEnabled}
              onChange={(e) => setFormData({...formData, heroAdEnabled: e.target.checked})}
            />
            <div className="w-14 h-7 bg-dark-bg peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:bg-rocket border border-dark-border"></div>
          </label>
        </div>

        <div className="space-y-4 opacity-100 transition-opacity" style={{ opacity: formData.heroAdEnabled ? 1 : 0.5 }}>
          <div>
            <label className="block text-sm text-muted mb-1">Headline</label>
            <input 
              type="text" 
              disabled={!formData.heroAdEnabled}
              value={formData.headline} 
              onChange={e => setFormData({...formData, headline: e.target.value})} 
              className="w-full bg-dark-bg border border-dark-border rounded p-3 focus:border-rocket outline-none disabled:opacity-50" 
            />
          </div>

          <div>
            <label className="block text-sm text-muted mb-1">Sub-headline</label>
            <textarea 
              disabled={!formData.heroAdEnabled}
              value={formData.subheadline} 
              onChange={e => setFormData({...formData, subheadline: e.target.value})} 
              className="w-full bg-dark-bg border border-dark-border rounded p-3 focus:border-rocket outline-none h-24 disabled:opacity-50" 
            />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm text-muted mb-1">CTA Text</label>
              <input 
                type="text" 
                disabled={!formData.heroAdEnabled}
                value={formData.ctaText} 
                onChange={e => setFormData({...formData, ctaText: e.target.value})} 
                className="w-full bg-dark-bg border border-dark-border rounded p-3 focus:border-rocket outline-none disabled:opacity-50" 
              />
            </div>
            <div>
              <label className="block text-sm text-muted mb-1">CTA Link</label>
              <input 
                type="text" 
                disabled={!formData.heroAdEnabled}
                value={formData.ctaLink} 
                onChange={e => setFormData({...formData, ctaLink: e.target.value})} 
                className="w-full bg-dark-bg border border-dark-border rounded p-3 focus:border-rocket outline-none disabled:opacity-50" 
              />
            </div>
          </div>
        </div>

        <div className="pt-4 border-t border-dark-border flex items-center justify-between">
          {saved ? (
            <span className="text-green-400 text-sm flex items-center"><SafeIcon name="Check" className="w-4 h-4 mr-1" /> Settings saved successfully</span>
          ) : <span></span>}
          <button type="submit" className="bg-rocket hover:bg-rocket-hover text-white px-6 py-2 rounded-md font-semibold transition-colors">
            Save Marketing Settings
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminAds;